import { useFormikContext } from "formik";
import Box from "@mui/material/Box";
import FormField from "layouts/Flow Designer/components/FormField";
import { getEnv } from "helpers/environment";
import { useFlowForm } from "../FlowForm/context";

const Settings = () => {
   const { values, errors, touched, setFieldValue } = useFormikContext();
   const {
      allowEditWorkflow,
      onErrorOptions,
      validateExecutionTimeoutDuration,
      fields: { executionTimeoutDuration, retryOnFail, maximumTries, waitBetweenTries, onError, notes, displayExecutionLogs }
   } = useFlowForm();
   const onErrorValue = onErrorOptions.find((option) => option.value === values.onError);

   return (
      <Box sx={{ padding: "0 3px 5px" }}>
         <FormField
            type={executionTimeoutDuration.type}
            label={executionTimeoutDuration.label}
            name={executionTimeoutDuration.name}
            validate={validateExecutionTimeoutDuration}
            error={errors[executionTimeoutDuration.name] && touched[executionTimeoutDuration.name]}
            onChange={(event) => {
               if (event.target.value < 0) event.target.value = 0;
               if (event.target.value > getEnv("EXECUTION_TIMEOUT_DURATION")) event.target.value = getEnv("EXECUTION_TIMEOUT_DURATION");
               setFieldValue(executionTimeoutDuration.name, event.target.value);
            }}
            required
            disabled={!allowEditWorkflow}
         />
         <FormField type={retryOnFail.type} label={retryOnFail.label} name={retryOnFail.name} error={errors[retryOnFail.name] && touched[retryOnFail.name]} disabled={!allowEditWorkflow} />
         {values.retryOnFail && (
            <>
               <FormField
                  type={maximumTries.type}
                  label={maximumTries.label}
                  name={maximumTries.name}
                  error={errors[maximumTries.name] && touched[maximumTries.name]}
                  onChange={(event) => {
                     if (event.target.value < 0) event.target.value = 0;
                     setFieldValue(maximumTries.name, event.target.value);
                  }}
                  disabled={!allowEditWorkflow}
               />
               <FormField
                  type={waitBetweenTries.type}
                  label={waitBetweenTries.label}
                  name={waitBetweenTries.name}
                  error={errors[waitBetweenTries.name] && touched[waitBetweenTries.name]}
                  onChange={(event) => {
                     if (event.target.value < 0) event.target.value = 0;
                     setFieldValue(waitBetweenTries.name, event.target.value);
                  }}
                  disabled={!allowEditWorkflow}
               />
            </>
         )}
         <FormField
            type={onError.type}
            label={onError.label}
            name={onError.name}
            error={errors[onError.name] && touched[onError.name]}
            options={onErrorOptions}
            defaultValue={onErrorValue}
            isDisabled={!allowEditWorkflow}
         />
         <FormField type={notes.type} label={notes.label} name={notes.name} error={errors[notes.name] && touched[notes.name]} isMultiline disabled={!allowEditWorkflow} />
         <FormField
            type={displayExecutionLogs.type}
            label={displayExecutionLogs.label}
            name={displayExecutionLogs.name}
            error={errors[displayExecutionLogs.name] && touched[displayExecutionLogs.name]}
            disabled={!allowEditWorkflow}
         />
      </Box>
   );
};

export default Settings;
